import { render } from "./EventConfig.vue?vue&type=template&id=668c53e2&scoped=true"
import script from "./EventConfig.vue?vue&type=script&lang=js"
export * from "./EventConfig.vue?vue&type=script&lang=js"

import "./EventConfig.vue?vue&type=style&index=0&id=668c53e2&scoped=true&lang=css"
import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=1&lang=css"

import exportComponent from "d:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668c53e2"]])

export default __exports__